@if (isLoadingEventInfo) {
  <app-loader diameter="40" class="my-5 mx-auto"/>
}

@if (!isLoadingEventInfo) {
  <div class="event" [appHelp]="faqItems">
    <ng-container *appLet="(appService.settings.asObservable() | async) as setting">
      @if (!setting?.isWidget) {
        <app-event-cover [event]="event" />
      }
      <div class="event__main-content">
        @if (!setting?.isWidget) {
          <app-event-info [event]="event" />
        }
      </div>
    </ng-container>
    <div class="event__main-content" *transloco="let t;">
      <app-event-custom-message
        [message]="event?.EventPersonalization?.platformPage"
        [translocoMessage]="event.resaleEnd ? t('events.resaleWillEndAt', {date: event.resaleEnd | date: 'dd/MM/yyyy' + t('common.at') +  'HH:mm':'':('language.locale' | transloco)}) : ''"
        />
        <app-sale-purchase />
      </div>
    </div>
  }
